import { render } from "./AccountNav.vue?vue&type=template&id=504c6ed7&ts=true"
import script from "./AccountNav.vue?vue&type=script&lang=ts"
export * from "./AccountNav.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__